import { faClock as faClockLight, faRocketLaunch as faRocketLaunchLight } from '@fortawesome/pro-light-svg-icons'
import { IconDefinition, faClock, faRocketLaunch } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { AUTOMATED, ONE_TIME } from '../outreach-message-types'

export const DISPLAY_ORDER = [ONE_TIME, AUTOMATED]

export const TABS = {
  [ONE_TIME]: {
    text: 'One-Time',
    value: ONE_TIME,
    getUrl: (url: string) => `${url}/one-time`,
    icons: {
      active: faClock,
      inactive: faClockLight,
    },
  },

  [AUTOMATED]: {
    text: 'Automated',
    value: AUTOMATED,
    getUrl: (url: string) => `${url}/automated`,
    icons: {
      active: faRocketLaunch,
      inactive: faRocketLaunchLight,
    },
  },
}

export const getIcon = (icons: { active: IconDefinition; inactive: IconDefinition }, active: boolean) => {
  const iconDoesNotExist = !icons.active || !icons.inactive
  const icon = active ? icons.active : icons.inactive

  if (iconDoesNotExist) return null
  return <FontAwesomeIcon icon={icon} />
}
